<div class="modal-header">
	<h4 class="modal-title">Neuer Punkt</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
	<label class="form-label mb-1">Punktart</label>
	<bp-punktart-picker [type]="bp.type" (typeChange)="onTypeChange($event)"></bp-punktart-picker>

	<!-- Pfeilrichtung für drehbare Symbole (Verhagerungspfeile). -->
	<div *ngIf="istPunktartDrehbar(bp.type)" class="mt-2">
		<label class="form-label mb-1">Pfeilrichtung</label>
		<bp-rotation-picker [type]="bp.type" [rotation]="bp.rotation" (rotationChange)="bp.rotation = $event"></bp-rotation-picker>
	</div>

	<wd-text-input *ngIf="istPunktartMitNummer(bp.type)" name="Nummer" [label]="bohrpunktNummerLabel(bp.type)" [(model)]="bp.header.nummer"></wd-text-input>
	<wd-date-input name="Aufnahmedatum" label="Aufnahmedatum" [(model)]="bp.header.aufnahme.datum"></wd-date-input>
	<!-- Kartierer-Feld bewusst entfernt: wird automatisch auf den Ersteller gesetzt
	     (siehe Komponente, kartierer = aktueller Nutzer) und ist an das Punkt-Eigentum
	     (workflow.createdBy) gekoppelt. Umhängen erfolgt nur über Detail-Formular/Batch
	     (Owner/Entwickler, canIReassignKartierer). -->

	<!-- Aus dem offenen Protokoll übernehmen: nur was angehakt ist (28.09.2026).
	     Adresse, Datum, Nummer, Labornummer und Bemerkungen gehen nie mit. -->
	@if (zeigeUebernahme()) {
		<div class="mt-3">
			<div class="form-label mb-2">{{ vorlageTitel() }}</div>
			<bp-abschnitt-wahl [quelle]="vorlage" [punktart]="bp.type" [(gewaehlt)]="gewaehlt"></bp-abschnitt-wahl>
		</div>
	}
</div>
<div class="modal-footer">
	<button ngbAutofocus type="button" class="btn btn-outline-secondary" (click)="onClose(false)"><i class="bi bi-download"></i>&nbsp;Anlegen</button>
	<button type="button" class="btn btn-outline-secondary" (click)="onClose(true)"><i class="bi bi-folder-plus"></i>&nbsp;Öffnen</button>
</div>
